module.exports = __webpack_public_path__ + "img/refresh_24px.3e93a47a.svg";